'use client'

/**
 * Everything that is not a 404, which in practice means the CMS could not be
 * reached or answered 500. A site being unreadable because its CMS is down
 * should say so rather than show a stack trace.
 */
export default function Error({ reset }: { error: Error; reset: () => void }) {
    return (
        <main>
            <h1>This site is temporarily unavailable</h1>
            <p>The CMS could not be reached. Nothing is wrong with the address you used.</p>
            <button type="button" onClick={reset} className="cursor-pointer">
                Try again
            </button>
        </main>
    )
}
